import { AxiosPromise } from 'axios';

import { GenericServices } from './generic.services';
import { IBaseService } from './base.sevice';
import { GenericBaseParameter } from '../models/base-parameter';
import Uri from '../common/uri/user-uri.constants'
import { IUserParameterModel } from '../models/user';
import { ApiResponse } from '../models/app-configuration';
import { deepClone } from 'fast-json-patch/lib/core';
import {commonUri} from "../common";
export class UserServices extends GenericServices implements IBaseService {
    listOfUsers(param: GenericBaseParameter<IUserParameterModel>) {
        return super.executeSelecting(param, Uri.default)
            .then((response: ApiResponse) => {
                console.log(response)
                if (response.isSuccess) {
                    console.log(response)
                    return Promise.resolve(response.data.items);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }
    // @ts-ignore
	updatingCompare<TValue, TResult>(originValue: TValue, value: TValue, path: string) {
	    return super.executeUpdatingCompare(originValue, value, path);
    }
    select<TValue, TResult>(params: TValue, path?: string): AxiosPromise<TResult> {
        return this.executeSelecting(params, path);
    }
	selectNotEndcodeURI<TValue, TResult>(params: TValue, path?: string): AxiosPromise<TResult> {
		return this.executeSelecting(params, path, false);
	}
    selectAsync<TValue, TResult>(params: TValue, path?: string): AxiosPromise<TResult[]> {
        return this.executeSelecting(params, path);
    }
	post<TValue, TResult>(params: TValue, path: string): AxiosPromise<TResult> {
		return this.executeSelectingPost(params, path);
    }
    create<TValue, TResult>(value: TValue, path?: string): Promise<TResult> {
        return super.executeCreating(value, path);
    }
    createAsync<TValue, TResult>(value: TValue, path?: string): AxiosPromise<TResult> {
        throw new Error('Method not implemented.');
    }
    update<TOriginalValue, TValue, TResult>(originVariable: TOriginalValue, value: TValue, path?: string): AxiosPromise<TResult> {
        throw new Error('Method not implemented.');
    }
    updateAsync<TOriginalValue, TValue, TResult>(originVariable: TOriginalValue, value: TValue, path?: string): AxiosPromise<TResult> {
        throw new Error('Method not implemented.');
    }
    selectBy<TValue, TResult>(value: TValue, path?: string): AxiosPromise<TResult> {
        return super.executeSelectBy(value, 'token/:domain/users');
    }
    selectByAsync<TValue, TResult>(value: TValue, path?: string): AxiosPromise<TResult> {
        throw new Error('Method not implemented.');
    }

    // @ts-ignore
    UpdateUserConfigAsync<TValue, TResult>(data: any, path: string): AxiosPromise<TResult> {
        return super.executePatch(data,path);
    }

    getUserInformation(id: string): AxiosPromise { 
        const uri = Uri.information.replace(':id', id);
        return super.executeSelecting(null, uri)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    upadteUserInformation(originEntity: any, entity: any) {
        const clonedOriginEntity = deepClone(originEntity);
        const clonedEntity = deepClone(entity);

        let path = Uri.updateInfo.replace(':id', entity.Id.toString());
        return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, path)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    getUserConfiguration() {
        return this.executeSelectingPost(
            {
            }, Uri.configuration)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            }).catch(error => Promise.reject(error))
    }

    updateUserConfiguration(originEntity: any, entity: any) {
        const clonedOriginEntity = deepClone(originEntity);
        const clonedEntity = deepClone(entity);
        return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, Uri.configuration)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    getTwoFactorLoginConfig(): AxiosPromise {
        return super.executeSelecting(null, Uri.twoFactorLoginConfig)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    generateQRCode(isNew: boolean = false): AxiosPromise {
        return super.executeSelectingPost({ IsNew: isNew}, Uri.generateQRCode)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    getQRCode(url: string): AxiosPromise {
        return super.executeSelecting(null, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    verifyQRCode(payload): AxiosPromise {
        return super.executeSelectingPost(payload, Uri.verifyQRCode)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    copyAgendaConfig(userIds): AxiosPromise {
        return super.executeSelectingPost({ UserIds: userIds}, Uri.copyAgendaConfig)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else {
                    return Promise.reject(response.message);
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }
    changePasswordUser(userId: any, requestModel: any): AxiosPromise { 
            let  path= Uri.changePasswordUser.replace(':id',userId);
            return super.executeSelectingPost( requestModel, path)
                    .then((response: ApiResponse) => {
                        if(response.isSuccess){
                            return Promise.resolve(response.data);
                        }
                        else{
                            return Promise.reject(response)
                        }
                    })
                    .catch(ex => {
                        return Promise.reject(ex);
                    })
    }

    getUserNotificationConfiguration(): AxiosPromise {
        return super.executeSelectingPost({}, Uri.getNotificationConfig)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response)
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    upadteNotificationConfig(originEntity: any, entity: any) {
        const clonedOriginEntity = deepClone(originEntity);
        const clonedEntity = deepClone(entity);
        return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, Uri.getNotificationConfig)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    getCompaniesList(apiKey: String): AxiosPromise {
        let  path = `${Uri.getCompaniesList}?apiKey=${apiKey}`;
        return this.executeSelecting({}, path)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response)
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    getBusinessList(apiKey): AxiosPromise {
        let  path= Uri.getBusinessList.replace(':apiKey', encodeURIComponent(apiKey));
        return this.executeSelecting({}, path)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response)
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    registerRealEstateAgent(requestModel: any) {
        return this.executeSelectingPost(requestModel, Uri.registerRealEstateAgent)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    userConfigurationES(requestModel: any) {
        return this.executePatch(requestModel, Uri.userConfigurationEX)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    enableUserConfigurationES(requestModel: any) {
        return this.executeSelectingPost(requestModel, Uri.userConfigurationEX)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    userGenerateToken(requestModel: any){
        return this.executeSelectingPost(requestModel, Uri.userGenerateToken)
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    userPrepareRegisterAccount(email: String): AxiosPromise {
        let  path = `${Uri.userPrepareRegisterAccount}?email=${email}`;
        return this.executeSelecting({}, path)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response)
                }
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    }

    userApplyRegisterAccount(requestModel: any){
        return this.executeSelectingPost(requestModel, Uri.userApplyRegisterAccount)
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    configurationsRegisterAccount(payload: any, supplierName){
        return this.executeSelectingPost(payload, Uri.configurationsRegisterAccount.replace(':supplierName', supplierName))
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    configurationsRegisterAccountSave(payload: any, supplierName){
        return this.executeSelectingPost(payload, Uri.configurationsRegisterAccountSave.replace(':supplierName', supplierName))
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    configurationColorSubStatus(payload: any){
        return this.executeSelectingPost(payload, Uri.configuration)
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    configurationsExternalService(){
        return this.executeSelecting(null, Uri.configurationsExternalService)
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    saveConfigurationES(payload: any) {
        return this.executePatch(payload, Uri.saveConfigurationsExternalService)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            })
            .catch(error => Promise.reject(error))
    }

    getUserRights(){
        return this.executeSelecting(null, Uri.getConfigurationsUserRights)
        .then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(response.data)
                : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    configurationSeeAgenda(params) {
        return this.executeSelecting(params, commonUri.getConfigByKey)
        .then((response: ApiResponse) => {
            console.log(response)
            return Promise.resolve(response.data)
        })
        .catch(error => Promise.reject(error))
    }
}